// Import aller Bootstrap-JS
import * as bootstrap from 'bootstrap';
import '../scss/code.scss';
// import '../scss/navbar-footer.scss';
